import React from "react";
import _ from "lodash";
import styled from "styled-components";
import moment from "moment";
import { connect } from "formik";
import { DatePicker } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyleDatePicker = styled(DatePicker)`
  && {
    width:100%;
  }
`;
const SideLabelDateInput = ({ label, fieldName, placeholder, formik, isDisabled, ...otherProps }) => {
  const { values } = formik;
  const val = _.get(values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{val ? moment(val).format("MM/DD/YYYY") : "--"}</ViewOnlyDiv>}
      {!isDisabled && <StyleDatePicker
        fieldName={fieldName}
        placeholder={placeholder}
        {...otherProps}
      />}
    </LateralField>
  );
};
export default connect(SideLabelDateInput);
